import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
  Switch,
  Dimensions,
  TextInput,
  FlatList,
  Modal,
  Button,
  TouchableWithoutFeedback,
  Pressable,
  ImageBackground,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import CustomCalendar from "../../Components/CustomCalenderThree";
import { VehiData } from "../../Constants/Data";
const { width, height } = Dimensions.get("window");
// import MapView, { PROVIDER_GOOGLE } from "react-native-maps";
// import StarRating from "../../Components/StarRating";
// import { BarChart, LineChart } from "react-native-chart-kit";

// import { useTranslation } from "react-i18next";
// import PieChart from "react-native-pie-chart";
// import ChangelogoOne from "../MasterSettingOne/ChangelogoOne";

const VehicleInspectionDashboard = ({ navigation }) => {
  const screenWidth = Dimensions.get("window").width;
  const widthAndHeight = 175;
  const series = [723, 321, 123, 189];
  const seriess = [723, 321, 223, 189];
  const seriesss = [723, 321, 223, 189];

  const sliceColorrr = ["dodgerblue", "skyblue", "yellow", "brown"];
  const sliceColorr = ["#F45050", "#3C486B", "#F9D949", "#926C6C"];
  const sliceColor = ["#62C572", "#FF9932", "#D95B5D", "#454545"];
  const [modalVisibleone, setModalVisibleone] = useState(false);
  const toggleSwitch = () => setIsEnable((previousState) => !previousState);
  const [isEnable, setIsEnable] = useState(false);
  const toggleSwitched = () => setIsEnabled((previousState) => !previousState);
  const [isEnabled, setIsEnabled] = useState(false);
  // const handleBoxPressbtn = (item) => {
  //   setSelectedBox(item);
  // };
  const [activeIndex, setActiveIndex] = useState(1);
  // const { t } = useTranslation(["common"]);

  // const handleTextPress = (index) => {
  //   setActiveIndex(index);
  // };

  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  const [DotModal, setDotModal] = useState(false);

  const [coordinates] = useState([
    {
      latitude: 48.8587741,

      longitude: 2.2069771,
    },

    {
      latitude: 48.8323785,

      longitude: 2.2069771,
    },
  ]);
  //----
  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        data: [20, 45, 28, 80, 99, 43, 56, 30, 26, 45, 28, 80, 99],
      },
    ],
  };
  const dataa = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        data: [20, 45, 28, 80, 99, 43],
      },
    ],
  };
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <Text
            style={{
              color: AppColors.brown1,
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              marginLeft: 20,
            }}
          >
            {t("common:translation.Vehicle Inspection- Dashboard")}
          </Text>
        </View>

        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <TouchableOpacity
          // onPress={() => navigation.navigate("CusEmailIssue")}
          >
            <Image
              source={AppImages.Plus}
              style={{
                width: 18,
                height: 18,
                resizeMode: "contain",
                marginLeft: 20,
              }}
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
        <ScrollView
          style={{ backgroundColor: AppColors.white, marginTop: 20 }}
          showsVerticalScrollIndicator={false}
        >
          <View
            style={{
              flexDirection: "row",

              alignItems: "center",

              // marginTop: 20,
              marginHorizontal: 20,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",

                marginTop: 20,
                // width: "100%",
                height: height * 0.07,
                borderRadius: 10,
                borderColor: AppColors.sandal,
                //  height: height * 0.07,
                borderWidth: 1,
                height: 45,
                flex: 1,
              }}
            >
              <TextInput
                placeholder={t("common:translation.Search Car...")}
                placeholderTextColor="#ACACAC80"
                style={{
                  fontSize: 12,
                  // alignItems: "center",
                  fontFamily: AppFonts.OverpassMedium,
                  // width: "90%",
                  paddingLeft: 13,
                }}
              />
              <View style={styles.vee}>
                <Image
                  source={AppImages.search}
                  style={{
                    width: 17,
                    height: 17,
                    resizeMode: "contain",
                    marginRight: 11,
                  }}
                  resizeMode="contain"
                />
              </View>
            </View>

            {/* <TouchableOpacity style={styles.too}></TouchableOpacity> */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginLeft: 13,
                marginTop: 10,
              }}
            >
              <Image
                source={AppImages.Import}
                style={{ height: 20, width: 22 }}
                resizeMode="contain"
              />

              <Image
                source={AppImages.Shareit}
                style={{ height: 25, width: 23, marginLeft: 16 }}
                resizeMode="contain"
              />
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginHorizontal: 20,
              justifyContent: "space-between",
            }}
          >
            {/* <TouchableOpacity style={{ flex: 1 }}>
              <View
                style={{
                  flexDirection: "row",
                  paddingLeft: 20,
                  alignItems: "center",

                  marginTop: 20,
                  // width: "100%",
                  height: height * 0.07,
                  borderRadius: 10,
                  borderColor: AppColors.sandal,
                  //  height: height * 0.07,
                  borderWidth: 1,
                  height: 45,
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    color: AppColors.dualbrown,
                    fontSize: 14,
                    fontFamily: AppFonts.OverpassRegular,
                    // width: "50%",
                  }}
                >
                  {t("common:translation.Start Date")}
                </Text>
                <Image
                  source={AppImages.Calendar}
                  style={{
                    width: 16,
                    height: 16,
                    resizeMode: "contain",
                    marginRight: 10,
                  }}
                />
              </View>
            </TouchableOpacity> */}
            <CustomCalendar placeholder={"Start Date"} />
            <View style={{ marginLeft: 20 }} />
            <CustomCalendar placeholder={"End Date"} />
          </View>
          <View
            style={{
              flexDirection: "row",
              paddingLeft: 20,
              alignItems: "center",

              marginTop: 20,
              // width: "100%",
              // height: height * 0.07,
              borderRadius: 10,
              borderColor: AppColors.sandal,
              //  height: height * 0.07,
              borderBottomWidth: 1,
              // borderBottomWidth: 0.5,
              //height: 45,
              flex: 1,
              //  marginLeft:20
            }}
          ></View>
          <ScrollView
            style={{ marginHorizontal: 0 }}
            showsVerticalScrollIndicator={false}
          >
            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View style={{}}>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Inspection Summary")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ marginHorizontal: 20, marginTop: 20 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassMedium,
                          // width: "50%",
                        }}
                      >
                        {t("common:translation.Total Inspection")}
                      </Text>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassSemiBold,
                          // width: "50%",
                        }}
                      >
                        5000
                      </Text>
                    </View>
                    <View>
                      <View
                        style={{
                          backgroundColor: "#04B54C",
                          borderRadius: 20,
                          height: 35,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: AppColors.white,
                            fontSize: 12,
                            fontFamily: AppFonts.OverpassMedium,
                            //   paddingVertical:10,
                            paddingHorizontal: 8,
                            // width: "50%",
                          }}
                        >
                          Increased by 50%
                        </Text>
                      </View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 8,
                          fontFamily: AppFonts.OverpassMedium,
                          // width: "50%",
                        }}
                      >
                        *As per last month{" "}
                      </Text>
                    </View>
                  </View>
                  <View style={{ marginTop: 20 }}></View>
                  {/* <LineChart
                    data={data}
                    width={screenWidth * 0.8}
                    height={200}
                    chartConfig={{
                      fillShadowGradient: "white",
                      fillShadowGradientOpacity: 0,
                      fillShadowGradientFrom: "white",
                      fillShadowGradientTo: "white",
                      // backgroundColor:"red",
                      backgroundGradientFrom: "#ffffff",
                      backgroundGradientTo: "#ffffff",
                      decimalPlaces: 0,
                      color: (opacity = 0.1) => `#8F4300`,
                      labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
                      propsForDots: {
                        r: "3",
                        strokeWidth: "2",
                      },

                      propsForBackgroundLines: {
                        stroke: "transparent",
                      },
                    }}
                    bezier={false}
                  /> */}
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View style={{}}>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Inspection Status")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ marginHorizontal: 20, marginVertical: 20 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Total Inspection")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassSemiBold,
                        lineHeight: 15,
                        marginRight: 10,
                      }}
                    >
                      :
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassBold,
                        lineHeight: 15,
                      }}
                    >
                      1000
                    </Text>
                    <Image
                      source={AppImages.Reduparrow}
                      style={{
                        width: 14,
                        height: 14,
                        resizeMode: "contain",
                        marginLeft: 5,
                      }}
                    />
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Checked & Ok")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassSemiBold,
                        lineHeight: 15,
                        marginRight: 10,
                      }}
                    >
                      :
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassBold,
                        lineHeight: 15,
                      }}
                    >
                      56000
                    </Text>
                    <Image
                      source={AppImages.Greendownarrow}
                      style={{
                        width: 16,
                        height: 16,
                        resizeMode: "contain",
                        marginLeft: 5,
                      }}
                    />
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Require Attention")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassSemiBold,
                        lineHeight: 15,
                        marginRight: 10,
                      }}
                    >
                      :
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassBold,
                        lineHeight: 15,
                      }}
                    >
                      50
                    </Text>
                    <Image
                      source={AppImages.Greendownarrow}
                      style={{
                        width: 16,
                        height: 16,
                        resizeMode: "contain",
                        marginLeft: 5,
                      }}
                    />
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Immediate Attention")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassSemiBold,
                        lineHeight: 15,
                        marginRight: 10,
                      }}
                    >
                      :
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassBold,
                        lineHeight: 15,
                      }}
                    >
                      20
                    </Text>
                    <Image
                      source={AppImages.Reduparrow}
                      style={{
                        width: 14,
                        height: 14,
                        resizeMode: "contain",
                        marginLeft: 5,
                      }}
                    />
                  </View>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginRight: 20,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Top Spends by Vehicles")}
                      </Text>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.View All")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 20,
                    marginTop: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      // width: "50%",
                    }}
                  >
                    {t("common:translation.Total Spend")}
                  </Text>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginLeft: 20,
                      // width: "50%",
                    }}
                  >
                    Johnath Doe
                  </Text>
                </View>
                {/* <BarChart
                  data={dataa}
                  width={300}
                  height={200}
                  chartConfig={{
                    backgroundGradientFrom: "#ffffff",
                    backgroundGradientTo: "#ffffff",
                    decimalPlaces: 0,
                    color: (opacity = 1) => `rgba(156, 73, 0, ${opacity})`,
                    labelColor: (opacity = 1) => `rgba(156, 73, 0, ${opacity})`,
                  }}
                  style={{
                    marginVertical: 8,
                    borderRadius: 16,
                  }}
                /> */}
              </View>
            </View>
            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginRight: 20,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Inspection This Month")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 20,
                    marginTop: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      // width: "50%",
                    }}
                  >
                    {t("common:translation.Total Inspection")}
                  </Text>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginLeft: 20,
                      // width: "50%",
                    }}
                  >
                    500
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: 20,
                  }}
                >
                  <View style={{ width: "50%" }}>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#62C572",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Checked and OK")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#FF9932",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Require Attention")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#D95B5D",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Immediate Attention")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#454545",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Dead Vehicles")}
                      </Text>
                    </View>
                  </View>
                  {/* <View style={{ width: "50%" }}>
                    <PieChart
                      widthAndHeight={screenWidth * 0.4}
                      series={series}
                      sliceColor={sliceColor}
                      coverRadius={0.75}
                      coverFill={"#FFF"}
                    ></PieChart>
                  </View> */}
                </View>
              </View>
            </View>

            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginRight: 20,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Top Spend Groups")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 20,
                    marginTop: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      // width: "50%",
                    }}
                  >
                    {t("common:translation.Total Spend by ")}
                  </Text>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginLeft: 20,
                      // width: "50%",
                    }}
                  >
                    Redbytes
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: 20,
                  }}
                >
                  <View style={{ width: "50%" }}>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#F45050",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Fleet Manager")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#3C486B",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Driver")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#F9D949",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Vehicle Assistant")}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <View
                        style={{
                          width: 15,
                          height: 15,
                          backgroundColor: "#926C6C",
                        }}
                      ></View>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassMedium,
                          marginLeft: 10,
                        }}
                      >
                        {t("common:translation.Supervisor's")}
                      </Text>
                    </View>
                  </View>
                  {/* <View style={{ width: "50%" }}>
                    <PieChart
                      widthAndHeight={screenWidth * 0.4}
                      series={seriess}
                      sliceColor={sliceColorr}
                      coverRadius={0.75}
                      coverFill={"#FFF"}
                    ></PieChart>
                  </View> */}
                </View>
              </View>
            </View>

            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      // flexDirection: "row",
                      marginLeft: 20,
                      // paddingBottom: 14,
                      // alignItems: "center",
                    }}
                  >
                    <View style={{}}>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 18,
                          fontFamily: AppFonts.OverpassBold,
                          paddingVertical: 18,
                        }}
                      >
                        {t("common:translation.Summary Of Fault Type")}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ marginHorizontal: 20, marginVertical: 20 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Engine operations")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      58 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Brake system")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      48 Vehicles
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Tires")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      48 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Fuel system")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      38 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Lightning device")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      35 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Safety equipment's")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      20 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Steering mechanism")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      28 Vehicles
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {t("common:translation.Suspensions")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,

                        marginRight: 10,
                      }}
                    >
                      18 Vehicles
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20 }}>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  // paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    {
                      borderWidth: 1,
                      borderColor: "#9C49001A",
                      backgroundColor: AppColors.sandal,
                      borderRadius: 10,
                    },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 18,
                        fontFamily: AppFonts.OverpassBold,
                        paddingVertical: 18,
                        marginLeft: 20,
                      }}
                    >
                      {t("common:translation.Inspection Log")}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassMedium,
                        paddingVertical: 18,
                      }}
                    >
                      {t("common:translation.View All")}
                    </Text>
                  </View>
                </View>
                <FlatList
                  data={VehiData}
                  renderItem={() => (
                    <View style={{ marginHorizontal: 20 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          marginTop: 10,
                        }}
                      >
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            width: "50%",
                            fontFamily: AppFonts.OverpassSemiBold,
                          }}
                        >
                          01-01-2023, 03:15 PM
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            width: "50%",
                            textAlign: "right",
                            fontFamily: AppFonts.OverpassSemiBold,
                          }}
                        >
                          Fleet Manager John Doe
                          <Text
                            style={{
                              color: AppColors.dualbrown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassMedium,
                            }}
                          >
                            {"\n"}inspected
                          </Text>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassSemiBold,
                              marginLeft: 5,
                            }}
                          >
                            MH09GF1122
                          </Text>
                        </Text>
                      </View>
                    </View>
                  )}
                  ListFooterComponent={() => (
                    <View style={{ padding: 5 }}></View>
                  )}
                />
                {/* <View style={{ marginHorizontal: 20, marginVertical: 20 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      //  alignItems: "center",
                      justifyContent: "space-between",
                      // marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      01-01-2023, 03:15 PM
                    </Text>

                    <View
                      style={
                        {
                          //  flexDirection: "row",
                          // alignItems: "center",
                          // justifyContent:"space-between"
                          // marginTop: 10,
                        }
                      }
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        Fleet Manager John Doe
                      </Text>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassMedium,
                          }}
                        >
                          inspected
                        </Text>
                        <Text
                          style={{
                            color: AppColors.brown,
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginLeft: 5,
                          }}
                        >
                          MH09GF1122
                        </Text>
                      </View>
                    </View>
                  </View>
                </View> */}
              </View>
            </View>
          </ScrollView>
          <View style={{ padding: 10 }}></View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default VehicleInspectionDashboard;

const styles = StyleSheet.create({
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 8,
    width: "100%",
    // height: 40,
  },
  RegisterTxt: {
    // color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: width * 0.05, // Adjust the padding based on your needs
  },
  stepContainer: {
    alignItems: "center",
  },
  image: {
    width: width * 0.1, // Adjust the width based on your needs
    height: width * 0.1, // Adjust the height based on your needs
  },
  separator: {
    width: width * 0.03, // Adjust the separator width based on your needs
    alignSelf: "center",
    borderTopColor: AppColors.brown1,
    borderTopWidth: 0.7,
  },
  text: {
    marginTop: 8, // Adjust the margin based on your needs
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
  },
  whiteCircle: {
    position: "absolute",
    width: 150,
    height: 150,
    borderRadius: 125,
    backgroundColor: "white",
    alignSelf: "center",
    top: "50%",
    marginTop: -25,
  },
  // container: {
  //   // flex: 1
  //   justifyContent: 'center',
  //   alignItems: 'center',
  // },
  // selectedTimeBox: {
  //   backgroundColor: '#f2f2f2',
  //   padding: 10,
  //   borderRadius: 8,
  //   marginVertical: 10,
  // },
  // selectedTimeText: {
  //   fontSize: 16,
  // },
  // modalContainer: {
  //   flex: 1,
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   backgroundColor: 'rgba(0, 0, 0, 0.5)',
  // },
  // modalContent: {
  //   backgroundColor: 'white',
  //   padding: 16,
  //   borderRadius: 8,
  // },
  // timePickerContainer: {
  //   flexDirection: 'row',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   marginBottom: 10,
  // },
  // timeSeparator: {
  //   marginHorizontal: 10,
  // },
});
